import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-apply',
  templateUrl: './apply.component.html'
})
export class ApplyComponent implements OnInit {
  
  public partialDay:string="0";
  public leaveTypes:string="2";
  public startDay:string="0";
  public endDay:string="0";
  public halfDay:string="0";
  public halfDay2:string="0";

  constructor() { }

  ngOnInit() {
  }

}



// WEBPACK FOOTER //
// ./src/app/modules/leave/components/apply/apply.component.ts